/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'grid': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2 4.2C2 2.98 2.98 2 4.2 2h15.4c1.21 0 2.2.98 2.2 2.2v15.4a2.2 2.2 0 0 1-2.2 2.2H4.2A2.2 2.2 0 0 1 2 19.6V4.2zm4.4 2.2v11h11v-11h-11zm19.8-2.2c0-1.22.98-2.2 2.2-2.2h15.4c1.21 0 2.2.98 2.2 2.2v15.4a2.2 2.2 0 0 1-2.2 2.2H28.4a2.2 2.2 0 0 1-2.2-2.2V4.2zm4.4 2.2v11h11v-11h-11zm-4.4 22c0-1.22.98-2.2 2.2-2.2h15.4c1.21 0 2.2.98 2.2 2.2v15.4a2.2 2.2 0 0 1-2.2 2.2H28.4a2.2 2.2 0 0 1-2.2-2.2V28.4zm4.4 2.2v11h11v-11h-11zM2 28.4c0-1.22.98-2.2 2.2-2.2h15.4c1.21 0 2.2.98 2.2 2.2v15.4a2.2 2.2 0 0 1-2.2 2.2H4.2A2.2 2.2 0 0 1 2 43.8V28.4zm4.4 2.2v11h11v-11h-11z"/>'
  }
})
